import "./App.css";
import "./Component/main.css";
import {HashRouter as Router, Route, Routes} from "react-router-dom";
import {Container} from "react-bootstrap";
import Home from "./Component/Home";
import Imprint from "./Component/Imprint";
import React from "react";
import Privacy from "./Component/privacy";

function App() {
    return (
        <Container className="container-fluid p-0">
            <Router>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/Impressum" element={<Imprint/>}/>
                    <Route path="/Datenschutz" element={<Privacy/>}/>
                </Routes>
            </Router>
        </Container>
    );
}

export default App;
